import {diApi} from '@di-shared/api/di';
import {CreatePublicServiceConsentRequest} from '@di-shared/api/di/__generated';
import useApiError from '@di-shared/features/common/useApiError';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import usePendingHandler from '@shared/usePendingHandler';

export interface PublicServiceWithdrawBottomSheetProps {
  vin: string;
  category?: CreatePublicServiceConsentRequest.category;
}

function PublicServiceWithdrawBottomSheet({vin, category}: PublicServiceWithdrawBottomSheetProps) {
  const {t} = useInferableTranslation();
  const {resolveError} = useApiError();
  const puid = useEnvironmentStore((state) => state.puid);

  const [submitWithdraw] = usePendingHandler(
    async () => {
      if (category) {
        await diApi.publicService.deleteTermsConsent({puid, categoryList: [category]});
      }

      window.bottomSheetClose(true);
    },
    async (error) => {
      await resolveError(error);
    }
  );

  function getCategoryName(category?: CreatePublicServiceConsentRequest.category) {
    if (category === CreatePublicServiceConsentRequest.category.DEMERIT_EDUCATION) {
      return t('T20361');
    }
    if (category === CreatePublicServiceConsentRequest.category.HIGHWAY_UNPAID) {
      return t('T20362');
    }
    if (category === CreatePublicServiceConsentRequest.category.LICENSE_RENEWAL) {
      return t('T20360');
    }
    if (category === CreatePublicServiceConsentRequest.category.VEHICLE_INSPECTION) {
      return t('T30528');
    }
    return '';
  }

  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2
          id="bottomSheetTitle"
          className="bottom_sheet_title"
        >
          {t('T20410')}
        </h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label="close"
          onClick={() => window.bottomSheetClose(false)}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="bottom_sheet_title_sub">{t('T20406_$service', {service: getCategoryName(category)})}</strong>
          <div className="bottom_sheet_box">
            <div className="divider"></div>
            <p className="bottom_sheet_text">{t('T20407')}</p>
            <div className="divider"></div>
            <p className="bottom_sheet_text">{t('T20408')}</p>
          </div>
        </div>

        <div className="bottom_sheet_footer bottom_sheet_footer_complex">
          <button
            type="button"
            className="btn btn_large btn_outline"
            onClick={() => window.bottomSheetClose(false)}
          >
            {t('T10233')}
          </button>

          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={submitWithdraw}
          >
            {t('T20409')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PublicServiceWithdrawBottomSheet;
